module.exports = __webpack_public_path__ + "img/wz_02.4421389f.jpg";